import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: '0px',
    marginTop: '16px',
    marginRight: '16px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const AldNetAccount = ({
  type,
  title,
  aldnet_account,
  onChange,
  disabled,
  ...props
}) => {


  const handleChange = event => {
    onChange(event, 'aldnet_account')
  }

  const classes = useStyles();

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      {/*<TextField
        id="aldnet_account_number"
        disabled={disabled}
        name="aldnet_account_number"
        type="text"
        label="Nro Cuenta ALDNET"
        placeholder="Ingrese el nro de cuenta de ALDNET"
        onChange={handleChange}
        value={aldnet_account.aldnet_account_number}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{min: "0", style:{minWidth: 200, fontSize: '0.75rem'}}}
      />*/}

      <TextField
        id="aldnet_account_code"
        disabled={disabled}
        name="aldnet_account_code"
        type="text"
        label="Codigo ALDNET"
        placeholder="Ingrese el codigo de ALDNET"
        onChange={handleChange}
        value={aldnet_account.aldnet_account_code}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{min: "0", style:{minWidth: 200, fontSize: '0.75rem'}}}
      />
      <TextField
        id="aldnet_account_test_code"
        disabled={disabled}
        name="aldnet_account_test_code"
        type="text"
        label="Codigo ALDNET Test"
        placeholder="Ingrese el codigo de test de ALDNET"
        onChange={handleChange}
        value={aldnet_account.aldnet_account_test_code}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{min: "0", style:{minWidth: 200, fontSize: '0.75rem'}}}
      />


	</React.Fragment>
	)
}

AldNetAccount.defaultProps = {
  type: "text",
  className: "",
}

AldNetAccount.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
}

export default AldNetAccount;	